import { useState } from 'react';
import { AdvancedFilterFormControllerProps } from './FilterFormController';
import { Module } from './moduleConfig';
import { FilterDialog } from './FilterDialog';
import { SaveDialog } from './modals/SaveDialog';
import { DeleteDialog } from './modals/DeleteDialog';
import { RenameDialog } from './modals/RenameDialog';
import { DIALOG_STEPS, DialogStep } from './modals/constants';
import { FilterDialogProps } from './types';

export interface FilterFormProps extends AdvancedFilterFormControllerProps {
  open: boolean;
  module: Module;
}

export type { FilterDialogProps };

function FilterDialogManager({ open, onClose, module }: FilterFormProps) {
  const [dialog, setDialog] = useState<DialogStep>(DIALOG_STEPS.FILTER_SELECT);
  const [filterSetToDelete, setFilterSetToDelete] = useState<string | null>(null);
  const [filterSetToRename, setFilterSetToRename] = useState<string | null>(null);

  // Reset dialog state when the dialog is closed
  const handleClose = () => {
    setDialog(DIALOG_STEPS.FILTER_SELECT);
    setFilterSetToDelete(null);
    setFilterSetToRename(null);
    onClose();
  };

  const renderDialog = () => {
    switch (dialog) {
      case DIALOG_STEPS.FILTER_SELECT:
        return (
          <FilterDialog
            open={open}
            onClose={handleClose}
            module={module}
            setDialog={setDialog}
            setFilterSetToDelete={setFilterSetToDelete}
            setFilterSetToRename={setFilterSetToRename}
            currentDialog={dialog}
          />
        );
      case DIALOG_STEPS.FILTER_SAVE:
        return <SaveDialog open={open} onClose={handleClose} setDialog={setDialog} />;
      case DIALOG_STEPS.FILTER_RENAME:
        return (
          <RenameDialog open={open} onClose={handleClose} setDialog={setDialog} filterSetToRename={filterSetToRename} />
        );
      case DIALOG_STEPS.FILTER_DELETE:
        return (
          <DeleteDialog open={open} onClose={handleClose} setDialog={setDialog} filterSetToDelete={filterSetToDelete} />
        );
      case DIALOG_STEPS.FILTER_MERGE:
        return (
          <FilterDialog
            open={open}
            onClose={handleClose}
            module={module}
            setDialog={setDialog}
            setFilterSetToDelete={setFilterSetToDelete}
            setFilterSetToRename={setFilterSetToRename}
            currentDialog={dialog}
          />
        );
      default:
        return null;
    }
  };

  return renderDialog();
}

export { FilterDialogManager };
